export class Documents {
    file:File;
}

export class uploadException
{
    jobNumber:string;
}

export class bulkExcel{
    srNo:number;
    jobNumber:string;
    remarks:string;
}